
  import { defineComponent } from 'vue';

  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';

  import EChartsHorizontalBar from '@/components/ChartComponents/apacheEcharts/EChartsHorizontalBar.vue';
  import EChartsVerticalBar from '@/components/ChartComponents/apacheEcharts/EChartsVerticalBar.vue';
  import type { TEchartsBarDatasetItem } from '@/components/ChartComponents/apacheEcharts/types';

  type TTableRow = {
    id: number;
    data: string[];
  };

  type TAssociationData = {
    labels: string[];
    tableData: TTableRow[];
    tableDataTwo: TTableRow[];
  };

  const CHART_YEAR_LABELS = [
    '2012',
    '2013',
    '2014',
    '2015',
    '2016',
    '2017',
    '2018',
    '2019',
    '2020',
    '2021',
    '2022',
  ] as const;

  const ASSOCIATION_ACTS_CHART_DATA = [10, 20, 40, 24, 30, 9, 21];

  const ASSOCIATION_ACTS_CHART_COLORS = ['#0093BA', '#5bc6e3', '#337280', '#96d2e7', '#0093BA'];

  export default defineComponent({
    name: 'Association',
    components: { EChartsHorizontalBar, EChartsVerticalBar, SectionTitle },
    data(): TAssociationData {
      return {
        labels: [
          'Официальные сообщения\n' + 'евразийской экономической\n' + 'комиссии',
          'Акты высшего евразийского\n' + 'экономического совета ',
          'Акты евразийского\n' + 'межправительственного\n' + 'совета ',
          'Акты евразийской\n' + 'экономической\n' + 'комиссии',
          'Акты суда евразийского\n' + 'экономического союза\n',
          'Документы\n' + 'ТС и ЕЭП',
          'Меморандумы,\n' + 'заявления',
        ],
        tableData: [
          {
            id: 1,
            data: [
              'Акты высшего евразийского экономического совета (83)',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
            ],
          },
          {
            id: 2,
            data: [
              'Акты евразийского межправите-тельственного  совета (54)',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
            ],
          },
          {
            id: 3,
            data: [
              'Акты евразийской экономической комиссии (63)',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
            ],
          },
          {
            id: 4,
            data: [
              'Официальные сообщения евразийской экономической комиссии (123)',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
              '10',
            ],
          },
          {
            id: 5,
            data: ['Меморандумы, заявления (23)', '10', '10', '10', '10', '10', '10', '10', '10', '10', '10', '10'],
          },
          {
            id: 6,
            data: ['Документы\n' + 'ТС и ЕЭП', '10', '10', '10', '10', '10', '10', '10', '10', '10', '10', '10'],
          },
        ],
        tableDataTwo: [
          {
            id: 1,
            data: ['10', '10', '10', '10', '10', '10', '10', '10', '10', '10', '10'],
          },
        ],
      };
    },
    computed: {
      associationActsChartLabels(): string[] {
        return this.labels.map((label) => label.replace(/\n/g, ' ').trim());
      },
      associationActsChartDataset(): TEchartsBarDatasetItem[] {
        return [
          {
            data: ASSOCIATION_ACTS_CHART_DATA,
            colors: ASSOCIATION_ACTS_CHART_COLORS,
          },
        ];
      },
      chartYearLabels() {
        return CHART_YEAR_LABELS;
      },
      unionActsChartDataset(): TEchartsBarDatasetItem[] {
        return [
          {
            label: '',
            data: [25, 50, 10, 100, 30, 45, 34, 23, 10, 100, 95],
            color: '#0093BA',
          },
        ];
      },
      courtDecisionsChartDataset(): TEchartsBarDatasetItem[] {
        return [
          {
            label: '',
            data: [25, 50, 100, 100, 30, 45, 2, 23, 3, 100, 95],
            color: '#0093BA',
          },
        ];
      },
    },
  });
